exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".actions[data-v-25b1b738] {\n  width: 6%;\n}\n.asset-type-filter[data-v-25b1b738] {\n  width: 10%;\n  float: right;\n}\n.custom-paginated-table .action-buttons[data-v-25b1b738] {\n  width: 100px;\n}\n.card-icon[data-v-25b1b738] {\n  background: #3b5998 !important;\n}\n", ""]);

// exports
